module.exports = __webpack_public_path__ + "static/media/success-black.36fc10e4.svg";